import React from 'react';

export default function ApreciacaoContasExecutivo() {
    const contasPorAno = {
        '2000': {
            item: 1,
            norma: 'Resolução da Alepe nº 671',
            publicacao: 'DOE 16/06/2004',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2000.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=2859&tipo='
        },
        '2001': {
            item: 2,
            norma: 'Resolução da Alepe nº 591',
            publicacao: 'DOE 31/10/2002',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2001.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=8276&tipo='
        },
        '2002': {
            item: 3,
            norma: 'Resolução da Alepe nº 641',
            publicacao: 'DOE 06/11/2003',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2002.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=9371&tipo='
        },
        '2003': {
            item: 4,
            norma: 'Resolução da Alepe nº 709',
            publicacao: 'DOE 13/04/2005',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2003.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=3577&tipo='
        },
        '2004': {
            item: 5,
            norma: 'Resolução da Alepe nº 742',
            publicacao: 'DOE 10/11/2005',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2004.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=5739&tipo='
        },
        '2005': {
            item: 6,
            norma: 'Resolução da Alepe nº 801',
            publicacao: 'DOE 14/12/2006',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2005.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=5758&tipo='
        },
        '2006': {
            item: 7,
            norma: 'Resolução da Alepe nº 839',
            publicacao: 'DOE 10/10/2007',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2006.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=10132&tipo='
        },
        '2007': {
            item: 8,
            norma: 'Resolução da Alepe nº 898',
            publicacao: 'DOE 20/11/2008',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2007.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=10224&tipo='
        },
        '2008': {
            item: 9,
            norma: 'Resolução da Alepe nº 955',
            publicacao: 'DOE 10/12/2009',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2008.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=9232&tipo='
        },
        '2009': {
            item: 10,
            norma: 'Resolução da Alepe nº 1.017',
            publicacao: 'DOE 09/12/2010',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2009.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=1316&tipo='
        },
        '2010': {
            item: 11,
            norma: 'Resolução da Alepe nº 1.117',
            publicacao: 'DOE 23/05/2012',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2010.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=10251&tipo='
        },
        '2011': {
            item: 12,
            norma: 'Resolução da Alepe nº 1.180',
            publicacao: 'DOE 13/06/2013',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2011.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=10471&tipo='
        },
        '2012': {
            item: 13,
            norma: 'Resolução da Alepe nº 1.247',
            publicacao: 'DOE 07/05/2014',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2012.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=9637&tipo='
        },
        '2013': {
            item: 14,
            norma: 'Resolução da Alepe nº 1.343',
            publicacao: 'DOE 16/12/2015',
            ementa: 'Aprova a Prestação de Contas do Governador do Estado, relativa ao exercício de 2013.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=17751&tipo='
        },
        '2014': {
            item: 15,
            norma: 'Resolução da Alepe nº 1.669',
            publicacao: 'DOE 01/05/2020',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2014.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=50356&tipo='
        },
        '2015': {
            item: 16,
            norma: 'Resolução da Alepe nº 1.670',
            publicacao: 'DOE 01/05/2020',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2015.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=50357&tipo='
        },
        '2016': {
            item: 17,
            norma: 'Resolução da Alepe nº 1.671',
            publicacao: 'DOE 01/05/2020',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2016.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=50358&tipo='
        },
        '2017': {
            item: 18,
            norma: 'Resolução da Alepe nº 2.078',
            publicacao: 'DOE 18/06/2025',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2017.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=83559&tipo='
        },
        '2018': {
            item: 19,
            norma: 'Resolução da Alepe nº 2.079',
            publicacao: 'DOE 18/06/2025',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2018.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=83560&tipo='
        },
        '2019': {
            item: 20,
            norma: 'Resolução da Alepe nº 2.080',
            publicacao: 'DOE 18/06/2025',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2019.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=83561&tipo='
        },
        '2020': {
            item: 21,
            norma: 'Resolução da Alepe nº 2.081',
            publicacao: 'DOE 18/06/2025',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2020.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=83562&tipo='
        },
        '2021': {
            item: 22,
            norma: 'Resolução da Alepe nº 2.082',
            publicacao: 'DOE 18/06/2025',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2021.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=83563&tipo='
        },
        '2022': {
            item: 23,
            norma: 'Resolução da Alepe nº 2.083',
            publicacao: 'DOE 18/06/2025',
            ementa: 'Aprova as contas do Governador do Estado referentes ao exercício de 2022.',
            link: 'https://legis.alepe.pe.gov.br/texto.aspx?id=83564&tipo='
        },
        '2023': {
            item: 24,
            norma: 'Não houve apreciação das contas do Governador do Estado referentes ao exercício de 2023.',
            publicacao: 'Não disponível',
            ementa: 'Não houve apreciação das contas do Governador do Estado referentes ao exercício de 2023.',
            link: '#'
        },
        '2024': {
            item: 25,
            norma: 'Não houve apreciação das contas do Governador do Estado referentes ao exercício de 2024.',
            publicacao: 'Não disponível',
            ementa: 'Não houve apreciação das contas do Governador do Estado referentes ao exercício de 2024.',
            link: '#'
        }
    };

    const anosOrdenados = Object.keys(contasPorAno)
        .filter(ano => parseInt(ano) >= 2002)
        .sort((a, b) => parseInt(b) - parseInt(a));

    return (
        <div className="container py-4">
            <p>
                <small>
                    Você está em <a href="/prestacao-de-contas">Prestação de Contas</a> / Apreciação de Contas do Executivo Estadual
                </small>
            </p>
            <h1 className="mb-4">Apreciação de Contas do Executivo Estadual</h1>

            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle table-sm small">
                    <thead className="table-light">
                        <tr>
                            <th style={{ width: '80px' }}>ANO</th>
                            <th style={{ width: '400px' }}>RESOLUÇÃO</th>
                            <th style={{ width: '150px' }}>PROJETO</th>
                            <th style={{ width: '150px' }}>RESULTADO</th>
                            <th style={{ width: '150px' }}>ATA DA SESSÃO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {anosOrdenados.map((ano) => {
                            const conta = contasPorAno[ano];
                            return (
                                <tr key={ano}>
                                    <td><strong>{ano}</strong></td>
                                    <td>
                                        {conta.link === '#' ? (
                                            conta.norma
                                        ) : (
                                            <a href={conta.link} target="_blank" rel="noopener noreferrer">
                                                {conta.norma}
                                            </a>
                                        )}
                                    </td>
                                    <td>
                                        {parseInt(ano) >= 2017 && parseInt(ano) <= 2022 ? (
                                            <a 
                                                href={`https://www.alepe.pe.gov.br/downloads/apreciacao/prestacao-contas-${ano}.pdf`} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                VER
                                            </a>
                                        ) : null}
                                    </td>
                                    <td>
                                        {parseInt(ano) >= 2017 && parseInt(ano) <= 2022 ? (
                                            <a 
                                                href="https://www.alepe.pe.gov.br/downloads/apreciacao/resultados-2017-2022.pdf" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                VER
                                            </a>
                                        ) : null}
                                    </td>
                                    <td>
                                        {parseInt(ano) >= 2017 && parseInt(ano) <= 2022 ? (
                                            <a 
                                                href="https://www.alepe.pe.gov.br/downloads/apreciacao/atas-2017-2022.pdf" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                VER
                                            </a>
                                        ) : null}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
